export default {
  PPT: 'http://player-help.jkwwt.cn/%E9%80%89%E6%89%8B/%E9%80%89%E6%89%8B_PPT%E4%B8%AD%E6%8F%92%E5%85%A5%E8%A7%86%E9%A2%91%E7%9A%84%E6%93%8D%E4%BD%9C%E6%AD%A5%E9%AA%A4_office2016.html',
  VIDEO: 'http://player-help.jkwwt.cn/%E9%80%89%E6%89%8B/%E9%80%89%E6%89%8B_%E6%95%99%E5%AD%A6%E8%A7%86%E9%A2%91%E8%BD%AC%E7%A0%81%E5%8E%8B%E7%BC%A9%E7%9A%84%E6%93%8D%E4%BD%9C%E6%AD%A5%E9%AA%A4.html'
}



// WEBPACK FOOTER //
// ./src/model/guideFileUrls.js